export class CreditSummary {

    public courseCode: string;
    public grantedOrApprovedInCallistaUnspecified: number;
    public grantedOrApprovedInCallistaSpecified: number;
    public totalToBeRecordedInInCallistaUnspecified: number;
    public totalToBeRecordedInInCallistaSpecified: number;
    public unspecifiedCreditsInApplication: number;
    public specifiedCreditsInApplication: number;
    public messageIn2ndBox: string;
    public messageIn4thBox: string;
    public unspecifiedAcceptedByStudent: number;

    public specifiedAcceptedByStudent: number;
    constructor() {
        this.courseCode = "";
        this.unspecifiedCreditsInApplication = 0;
        this.specifiedCreditsInApplication = 0;
        this.grantedOrApprovedInCallistaSpecified = 0;
        this.grantedOrApprovedInCallistaUnspecified = 0;
        this.messageIn2ndBox = "";
        this.messageIn4thBox = "";
        this.specifiedAcceptedByStudent = 0;
        this.unspecifiedAcceptedByStudent = 0;
        this.totalToBeRecordedInInCallistaSpecified = 0;
        this.totalToBeRecordedInInCallistaUnspecified = 0;
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/CreditSummary.ts